var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        { staticClass: "vh-100 justify-content-center align-items-center" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "10", lg: "8" } },
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "div",
                        { staticClass: "form-header" },
                        [
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "https://artenara.es/portal-ciudadano/"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "form-header_logo img-fluid",
                                attrs: {
                                  src: require("../assets/ayto-artenara-logo.jpg"),
                                  alt: "Logo del Ayuntamiento de Artenara"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSubmit($event)
                            }
                          }
                        },
                        [
                          _c("h1", { staticClass: "form-title" }, [
                            _vm._v("Obtención de Certificado de Viajes")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                show: _vm.dismissCountDown,
                                fade: "",
                                variant: "danger"
                              },
                              on: { "dismiss-count-down": _vm.countDownChanged }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-body" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-lg-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    { staticClass: "required" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "document_type" }
                                        },
                                        [_vm._v("Tipo de Documento")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "document_type",
                                          options: _vm.document_type_options,
                                          state: _vm.validateState(
                                            "document_type"
                                          ),
                                          autocomplete: "off"
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.form.document_type.$touch()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.document_type.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.document_type,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.document_type.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { attrs: { id: "document_type" } },
                                        [
                                          !_vm.$v.form.document_type.required
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                          Debe seleccionar un tipo del documento.\n                        "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { staticClass: "required" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "document" }
                                        },
                                        [_vm._v("Documento")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "document",
                                          state: _vm.validateState("document"),
                                          "aria-describedby": "document",
                                          autocomplete: "off"
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.form.document.$touch()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.document.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.document,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "$v.form.document.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { attrs: { id: "document" } },
                                        [
                                          !_vm.$v.form.document.required
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                        Debe introducir un documento que lo identifique.\n                      "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$v.form.document.required &&
                                          !_vm.$v.form.document.validDocument
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                        El documento no debe contener espacios, puntos o guiones.\n                      "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-text",
                                        { attrs: { id: "document" } },
                                        [
                                          _vm._v(
                                            "No debe contener espacios, puntos o guiones."
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { staticClass: "required" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "name" }
                                        },
                                        [_vm._v("Nombre")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "name",
                                          state: _vm.validateState("name"),
                                          autocomplete: "off"
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.form.name.$touch()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.name.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.name,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "$v.form.name.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { attrs: { id: "name" } },
                                        [
                                          !_vm.$v.form.name.required
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                        Debe introducir su nombre.\n                      "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { staticClass: "required" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "surname" }
                                        },
                                        [_vm._v("Apellidos")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "surname",
                                          state: _vm.validateState("surname"),
                                          autocomplete: "off"
                                        },
                                        on: {
                                          blur: function($event) {
                                            return _vm.$v.form.surname.$touch()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.surname.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.surname,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "$v.form.surname.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { attrs: { id: "surname" } },
                                        [
                                          !_vm.$v.form.surname.required
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                        Debe introducir sus apellidos.\n                      "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { staticClass: "required" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "birthdate" }
                                        },
                                        [_vm._v("Fecha de nacimiento")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-input-group",
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "birthdate",
                                              state: _vm.validateState(
                                                "birthdate"
                                              ),
                                              type: "text",
                                              autocomplete: "off"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.$v.form.birthdate.$touch()
                                              },
                                              change: _vm.onInputBirthdateChange
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.birthdate.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.birthdate,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.birthdate.$model"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c("b-form-datepicker", {
                                                attrs: {
                                                  "date-format-options": {
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit"
                                                  },
                                                  "button-only": "",
                                                  "show-decade-nav": true,
                                                  "reset-button": "",
                                                  "hide-header": true,
                                                  right: "",
                                                  locale: "es-ES",
                                                  "aria-controls": "birthdate",
                                                  "label-calendar":
                                                    "Calendario",
                                                  "label-close-button":
                                                    "Cerrar",
                                                  "label-current-month":
                                                    "Mes actual",
                                                  "label-help":
                                                    "Use las teclas del cursor para navegar por las fechas del calendario",
                                                  "label-nav":
                                                    "Navegación del calendario",
                                                  "label-next-decade":
                                                    "Siguiente década",
                                                  "label-next-month":
                                                    "Siguiente mes",
                                                  "label-next-year":
                                                    "Siguiente año",
                                                  "label-prev-decade":
                                                    "Década anterior",
                                                  "label-prev-month":
                                                    "Mes anterior",
                                                  "label-prev-year":
                                                    "Año anterior",
                                                  "label-reset-button":
                                                    "Resetear",
                                                  "label-today": "Hoy"
                                                },
                                                on: {
                                                  context:
                                                    _vm.onDatePickerContext
                                                },
                                                model: {
                                                  value: _vm.datePickerSelected,
                                                  callback: function($$v) {
                                                    _vm.datePickerSelected = $$v
                                                  },
                                                  expression:
                                                    "datePickerSelected"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            { attrs: { id: "birthdate" } },
                                            [
                                              !_vm.$v.form.birthdate.required
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                          Debe introducir su fecha de nacimiento.\n                        "
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.$v.form.birthdate.required &&
                                              !_vm.$v.form.birthdate.date
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                          El formato de la fecha de nacimiento debe ser dd/mm/yyyy.\n                        "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _c("vue-recaptcha", {
                                        ref: "recaptcha",
                                        staticClass: "g-recaptcha",
                                        attrs: {
                                          sitekey:
                                            "6LdBHxcpAAAAAOxsQ-1dJHRCtNRSbxnPTguPNxY5",
                                          loadRecaptchaScript: true
                                        },
                                        on: {
                                          verify: _vm.verifyRecaptcha,
                                          expired: _vm.expiredRecaptcha,
                                          error: _vm.errorRecaptcha
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            type: "submit",
                                            variant: "primary",
                                            disabled: _vm.$v.$invalid
                                          }
                                        },
                                        [
                                          _vm.loading
                                            ? _c("b-spinner", {
                                                staticClass: "mr-2",
                                                attrs: { small: "" }
                                              })
                                            : _vm._e(),
                                          _vm.loading
                                            ? _c("span", [
                                                _vm._v("Obteniendo certificado")
                                              ])
                                            : _c(
                                                "span",
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: ["fas", "file"]
                                                    }
                                                  }),
                                                  _vm._v("Obtener certificado")
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { variant: "danger" },
                                          on: { click: _vm.resetForm }
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-2",
                                                attrs: { icon: ["fas", "undo"] }
                                              }),
                                              _vm._v("Borrar todo")
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            to: { name: "VerifyCertificate" },
                                            variant: "info"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  icon: ["fas", "check"]
                                                }
                                              }),
                                              _vm._v("Verificar certificado")
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-footer" })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8549bcd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8549bcd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GenerateCertificate.vue
// module id = null
// module chunks = 